import React from 'react';

import { getTrans } from '@/utils/tools';
import { Copywriting } from '@/utils/constants';

import './style.scss';

export default class ChatTransfer extends React.Component {
  render() {
    return <div className="chat-transfer">{getTrans(Copywriting.CHAT_TRANSFER)}</div>;
  }
}
